import { FeedbackReason } from 'graph_ql/feedback/types';

export interface ToggleReactionResponse {
    toggleReaction: ToggleReaction;
}

export interface ToggleReaction {
    collectionName: string;
    docId: string;
    reactionState: ReactionState;
    reactionNumber: any;
    __typename: string;
}

export interface ReactionState {
    isAlreadyLike: boolean;
    isAlreadyDislike: boolean;
    __typename: string;
}

export interface FeedbackSuggestion {
    id: string;
    consumerFullName: string;
    profileImageUrl: string;
    gender: string;
    feedbackReasons: FeedbackReason[];
    feedbackSubReason: string;
    updated: string;
}

export enum FEEDBACK_TRIGGER_TYPE {
    FEEDBACK = 'feedback',
    DISLIKE = 'dislike',
}
